import { Alert } from "react-bootstrap";

function ErrorAlert({ message }) {
	return (
		<Alert variant="danger" className="m-4">
			{message}
		</Alert>
	);
}

export default ErrorAlert;
